const c = {
  name: "Atm",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.3,14c0,0.7-0.6,1.2-1.2,1.2S6.8,14.7,6.8,14c0-0.7,0.6-1.2,1.2-1.2S9.3,13.3,9.3,14z"/>
		<path class="st0" d="M12,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.8,14.7,11.3,15.3,12,15.3z"
			/>
		<path class="st0" d="M17.3,14c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,12.8,17.3,13.3,17.3,14z"
			/>
		<path class="st0" d="M4,30v6h16v-6H4z M6,34v-2h12v2H6z"/>
		<path class="st0" d="M27,20v-5h-1v-2h10v2h-1v5c0,1.1-0.9,2-2,2h-4C27.9,22,27,21.1,27,20z M33,15h-4v5h4V15z"/>
		<path class="st0" d="M27,28.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C25.8,27.7,26.3,28.3,27,28.3z"
			/>
		<path class="st0" d="M32.3,27c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C31.7,25.8,32.3,26.3,32.3,27z"
			/>
		<path class="st0" d="M35,28.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C33.8,27.7,34.3,28.3,35,28.3z"
			/>
		<path class="st0" d="M28.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C27.7,33.8,28.3,34.3,28.3,35z"
			/>
		<path class="st0" d="M31,36.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C29.8,35.7,30.3,36.3,31,36.3z"
			/>
		<path class="st0" d="M36.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C35.7,33.8,36.3,34.3,36.3,35z"
			/>
		<path class="st0" d="M27,32.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C25.8,31.7,26.3,32.3,27,32.3z"
			/>
		<path class="st0" d="M32.3,31c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C31.7,29.8,32.3,30.3,32.3,31z"
			/>
		<path class="st0" d="M35,32.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C33.8,31.7,34.3,32.3,35,32.3z"
			/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h35c1.1,0,2-0.9,2-2V2c0-1.1-0.9-2-2-2H3z M22,2v24H2V3
			c0-0.5,0.5-1,1-1H22z M2,37v-9h20v10H3C2.5,38,2,37.5,2,37z M37,38H24V2h13c0.5,0,1,0.5,1,1v34C38,37.5,37.5,38,37,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Atm
};
